<template>
  <div class="category-style-page">
    <van-nav-bar
        title="定制商品"
        left-text="返回"

        left-arrow
        @click-left="goback"

    />

    <div class="product-info">
      <img :src="zhuBuProductColorImageUrl"/>
      <div>面料名称：{{ zhuBuProductNumber }}</div>
    </div>
    <div class="sort-bar">
      <div v-for="item in  types" @click="setTab(item.designCategoryName)"
           :class="['item ', {'active': activeitem==item.designCategoryName}]">{{ item.designCategoryName }}
      </div>

    </div>
    <van-list
        style="    padding-top: 10px;"
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="getStyleData"
    >
      <div @click="gotoNextStep(item)" class="series" :key="index" v-for="(item, index) in styles">
        <img :src="item.imageOne"/>
        <div class="info-top">
          <div class="title">{{ item.name }}</div>
          <!--<div class="price-2" v-if="item.price">
            ¥<span class="price-color">{{ item.price }}元</span>/{{ item.unitName }}
          </div>-->
        </div>
        <div class="tags">
          <div class="tag">
            <span v-if="item.zhuBuProductName">主布:{{ item.zhuBuProductName }}</span>
            <span v-if="item.peiBuBuProductName">配布:{{ item.peiBuBuProductName }}</span>
          </div>
        </div>
      </div>
    </van-list>
  </div>
</template>

<script>
export default {
  name: "DingzhiProduct",
  components: {},
  data() {
    return {
      loading: false,
      finished: false,
      styles: [],
      data: [],
      product: this.$store.getters.selZhuBu,
      productType: null,
      page: 1,
      pageNum: 10,
      types: [],
      activeitemname: '',
      zhuBuProductColorImageUrl:'',
      zhuBuProductId:0,
      zhuBuProductNumber:''
    };
  },

  mounted() {
    this.tagId = this.$route.query.tagId
    this.productType = this.$route.query.productType
    this.productid = this.$route.query.id
    // this.getStyleData()
    this.getInfo();
  },

  methods: {
    getInfo() {
      this.$http.post("/public/customerDesignList",this.productid).then(res => {
        this.loading = false
        this.finished = true
        this.types = res.designGroupDTOS || [];
        if (this.types) {
          this.setTab(this.types[0].designCategoryName);
        }
        this.zhuBuProductColorImageUrl = res.zhuBuProductColorImageUrl
        this.zhuBuProductId = res.zhuBuProductId
        this.zhuBuProductNumber = res.zhuBuProductNumber

      });
      /*let res = {
        "success": true,
        "status": 200,
        "message": "请求成功.",
        "timestamp": "2023-01-14T04:29:06.884+00:00",
        "handler": null,
        "exception": null,
        "data": [
          {
            "designCategoryName": "窗帘",
            "designs": [
              {
                "id": 5,
                "number": 5,
                "name": "光的梵唱",
                "designGroupId": 2,
                "designGroupName": "朗悦04",
                "pasteDirectionType": null,
                "curtainOpenModeId": null,
                "curtainOpenModeName": "右开",
                "installCraftId": null,
                "installCraftName": "穿杆",
                "processType": "FixHeight",
                "pleatTimesId": 4,
                "pleatTimesName": "2.20",
                "pleatDistance": null,
                "headPrice": null,
                "bodyPrice": null,
                "gauzePrice": null,
                "price": 1000,
                "isRecommend": null,
                "sortNumber": null,
                "headExpression": "左转角+成品宽+右转角",
                "bodyFixHeightExpression": "1",
                "bodyFixWidthExpression": "成品宽*褶倍",
                "gauzeFixHeightExpression": null,
                "gauzeFixWidthExpression": null,
                "imageOne": "https://beeda-curtain.oss-cn-beijing.aliyuncs.com/design/003ffeeb01114cb88b3a915bed027a63-Thumbnail.png",
                "imageTwo": null,
                "imageThree": null,
                "imageFour": null,
                "imageFive": null,
                "backgroundImage": null,
                "memo": null,
                "status": "ACTIVE",
                "addUser": "sys",
                "addTimeStamp": "2022-01-15T06:22:01.000+00:00",
                "modUser": "bddevc1",
                "modTimeStamp": "2022-03-15T10:02:56.078+00:00",
                "headSupplierId": 20235,
                "bodySupplierId": 20239,
                "gauzeSupplierId": 20239,
                "openMode": "YouDanKai",
                "installationCraft": "ChuanKong",
                "isCPMOnlineOrder": false,
                "processTemplateId": null,
                "semifinishedProductId": null,
                "isOnlineCustomerMadeOrder": null,
                "productGroupId": 12674,
                "isShowInSmartCurtain": true,
                "designCategory": "WaiLian",
                "designType": "DZKS"
              }
            ]
          },
          {
            "designCategoryName": "纱帘",
            "designs": [
              {
                "id": 6,
                "number": 6,
                "name": "绝美轻奢艺术",
                "designGroupId": 2,
                "designGroupName": "朗悦04",
                "pasteDirectionType": null,
                "curtainOpenModeId": null,
                "curtainOpenModeName": null,
                "installCraftId": null,
                "installCraftName": null,
                "processType": "FixWidth",
                "pleatTimesId": 4,
                "pleatTimesName": "2.20",
                "pleatDistance": null,
                "headPrice": null,
                "bodyPrice": null,
                "gauzePrice": null,
                "price": 1000,
                "isRecommend": null,
                "sortNumber": null,
                "headExpression": "左转角+成品宽+右转角",
                "bodyFixHeightExpression": "1",
                "bodyFixWidthExpression": "成品宽*褶倍",
                "gauzeFixHeightExpression": null,
                "gauzeFixWidthExpression": null,
                "imageOne": "https://beeda-curtain.oss-cn-beijing.aliyuncs.com/design/003ffeeb01114cb88b3a915bed027a63-Thumbnail.png",
                "imageTwo": null,
                "imageThree": null,
                "imageFour": null,
                "imageFive": null,
                "backgroundImage": null,
                "memo": null,
                "status": "ACTIVE",
                "addUser": "sys",
                "addTimeStamp": "2022-01-15T06:22:01.307+00:00",
                "modUser": null,
                "modTimeStamp": null,
                "headSupplierId": 20235,
                "bodySupplierId": 20239,
                "gauzeSupplierId": 20239,
                "openMode": null,
                "installationCraft": null,
                "isCPMOnlineOrder": false,
                "processTemplateId": null,
                "semifinishedProductId": null,
                "isOnlineCustomerMadeOrder": null,
                "productGroupId": 12674,
                "isShowInSmartCurtain": true,
                "designCategory": "ShaLian",
                "designType": "DZKS"
              }
            ]
          }
        ]
      }
      res.data = res.data || []
      this.types = res.data;
      if (this.types) {
        this.setTab(this.types[0].designCategoryName);
      }*/

    },
    setTab(itemname) {
      this.activeitem = itemname;
      this.styles = this.types.find((item) => item.designCategoryName == itemname).designs
    },
    getTypes() {
      this.types = [{text: "窗帘", id: 1}, {text: "抱枕", id: 2}, {text: "飘窗垫", id: 3}, {text: "窗幔", id: 4}]
    },
    goback() {
      history.go(-1)
    },
    gotoNextStep(item) {
      this.$store.getters.selProduct = item;
      this.$router.push('./dingzhidetail?productid=' + this.productid + '&designid=' + item.id);
    }
  },
};
</script>
<style scoped>
.product-info {
  display: flex;
  height: 150px;
  overflow: hidden;
  padding: 10px;
  font-size: 14px;
}

.product-info img {
  max-width: 100%;
  width: 150px;
  /* height: 200px; */
  /* overflow: hidden; */
  vertical-align: middle;
  margin-right: 10px;
  display: block;
}

.van-list {
  display: flex;
  flex-wrap: wrap;
  overflow: auto;
  margin-left: 10px;
}

.series {
  flex: 0 0 calc(50% - 10px);
  background: #fff;
  border-radius: 6px;
  margin-right: 10px;
  margin-bottom: 10px;
}

.series img {
  max-width: 100%;
}

.info-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding: 10px;
}

.series .tags {
  display: flex;

  padding: 0 10px 10px;
  font-size: 12px;
  align-items: center;
}

.series .tags .tag {
  color: #9B9B9B;
  margin-right: 10px;
}

.series .price-2 {
  font-size: 10px;
}

.price-color {
  color: var(--price-color);
  font-size: 14px;
  margin: 0 2px;
}

#app {
  padding-bottom: 0;
}
</style>
